function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h2',[_vm._v("The lifeblood of many digital sales funnel come from online advertising. However, in.")]),_vm._v(" "),_c('p',[_vm._v("WhiteBox tracks online advertising campaigns via "),_c('a',{attrs:{"href":"https://en.wikipedia.org/wiki/UTM_parameters","title":"UTM Parameters"}},[_vm._v("standard UTM attribution parameters")]),_vm._v(" and links them to phone calls, online inquiries and sales information. Via contextual and behavioral labeling mechanism and "),_c('a',{attrs:{"href":"https://en.wikipedia.org/wiki/AIDA_(marketing)","title":"AIDA Marketing Funnel"}},[_vm._v("AIDA model")]),_vm._v(" stage reporting, WhiteBox enables automated audience definition to Google, Facebook and other digital platforms. As a result digital marketers can:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Know return on advertising spent.")]),_vm._v(" "),_c('li',[_vm._v("Understand which campaigns deliver optimal results.")]),_vm._v(" "),_c('li',[_vm._v("Find keywords conversion rate.")]),_vm._v(" "),_c('li',[_vm._v("Enable advanced retargeting campaigns using the AIDA model.")])])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/interactions/ads","interaction":"ads","title":"(Advertising)|campaigns","image":"/img/interactions/1.svg"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }